// @ts-nocheck
import { lazy } from 'react';
export const CreateCompanyScreenAsync = lazy(
  () => import('./CreateCompanyScreen.tsx'),
);
